<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainForm">
	<!--Top Grid 4 Col-->
	<div class="Grid4Col">
		<label>First Name:</label>
		<input class="form-control" type="text" [(ngModel)]="FirstName" />

		<label>Home Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="HomePhone" placeholder="123-456-7890" />

		<label>Last Name:</label>
		<input class="form-control" type="text" [(ngModel)]="LastName" />

		<label>Work Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="WorkPhone" placeholder="123-456-7890" />

		<label>Address 1:</label>
		<input class="form-control" type="text" [(ngModel)]="Address1" />

		<label>Cell Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="CellPhone" placeholder="123-456-7890" />

		<label>Address 2:</label>
		<input class="form-control" type="text" [(ngModel)]="Address2" />

		<label>Email:</label>
		<input class="form-control" type="text" [(ngModel)]="Email" placeholder="abc@email.com" />
	</div>

	<!--City State Zip-->
	<div class="Grid6Col">
		<label>City:</label>
		<input class="form-control" type="text" [(ngModel)]="City" />

		<label>State:</label>
		<input class="form-control" style="width: 5em" type="text" maxlength="2" [(ngModel)]="State" />

		<label>Zip:</label>
		<input class="form-control" type="text" [(ngModel)]="Zip" />
	</div>

	<!--Select-->
	<div class="BottomGrid4Col">
		<label>Relationship:</label>
		<select class="form-control" [(ngModel)]="RelationshipID">
			<option *ngFor="let r of lstRelationship" [ngValue]="r.RelationshipID">
				{{ r.RelationshipDesc }}
			</option>
		</select>

		<label>Home Language:</label>
		<select class="form-control" [(ngModel)]="LanguageID">
			<option *ngFor="let r of lstLanguage" [ngValue]="r.LanguageID">
				{{ r.LanguageDesc }}
			</option>
		</select>
	</div>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
